import { some } from 'lodash';
import { API } from '../../../utils/api';
import { getCustomerBillingInformation } from '../dashboard/billing/billingAPI';
import {
  setLoading,
  setPayPlanOptions,
  setRevision,
  setStatementAccountPayPlanOptions,
} from './payPlanReducer';

export const getPayPlanOptions = (policyRef, payPlanTypesToFilter, notify) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    // when filtering out the payment plan types we remove falsy values, so we check if
    // any(lodash: some) of the pay plans name are included
    // and if they are we remove them, because lodash returns truthy we invert the value so it's filtered
    // full list of acceptable strings will be added to config readme
    return API.get(`policies/${policyRef}/paymentPlans`)
      .then((response) => {
        let filteredPayPlanOptions = response.data.applicationPayPlanListItems.filter((plan) => {
          return !some(payPlanTypesToFilter, (payPlan) => {
            return plan.name.includes(payPlan);
          });
        });
        dispatch(setPayPlanOptions(filteredPayPlanOptions));
      })
      .catch(() => {
        notify(
          'There was an issue getting available payment plans. Please contact your insurance agent.',
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
export const getPayPlansForStatementAccounts = (policyRef, notify, currentPayPlanType) => {
  return (dispatch) => {
    return API.get(`statementAccounts/paymentPlanList`)
      .then((response) => {
        let filteredPayPlanOptions = response?.data?.statementAccountPayPlanListItems
          .filter((plan) => {
            return !plan?.payPlanCd?.includes(currentPayPlanType); // remove current plan type from list of options.
          })
          .map((plan) => {
            return { ...plan, payPlan: { dayOfMonthInd: 'Required' } }; // all statement account plans required day ind
          });

        dispatch(setStatementAccountPayPlanOptions(filteredPayPlanOptions));
      })
      .catch(() => {
        notify(
          'There was an issue getting available payment plans. Please contact your insurance agent.',
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      });
  };
};
export const updatePayPlan = (
  customerId,
  body,
  notify,
  billingId,
  hasOpenBalance,
  billingAccountsCountLimit,
  billingStatusCd,
) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return API.post(`/policies/${customerId}/updatePaymentPlanRequest`, body)
      .then(async () => {
        notify('Your payment plan has been updated', {
          variant: 'success',
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top',
          },
        });

        return await dispatch(
          getCustomerBillingInformation(
            billingId,
            hasOpenBalance,
            billingAccountsCountLimit,
            billingStatusCd,
          ),
        );
      })
      .catch(() => {
        notify(
          'There was an issue updating your payment plan. Please contact your insurance agent.',
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
export const updateStatementPayPlan = (
  systemId,
  body,
  notify,
  billingId,
  hasOpenBalance,
  billingAccountsCountLimit,
  billingStatusCd,
) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return API.patch(`/statementAccounts/${systemId}?updateUnderlyingPolicies=true`, body)
      .then(async () => {
        notify('Your payment plan has been updated', {
          variant: 'success',
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top',
          },
        });

        return await dispatch(
          getCustomerBillingInformation(
            billingId,
            hasOpenBalance,
            billingAccountsCountLimit,
            billingStatusCd,
          ),
        );
      })
      .catch(() => {
        notify(
          'There was an issue updating your payment plan. Please contact your insurance agent.',
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
export const getStatementAccount = (statementaccountRef, notify) => {
  return (dispatch) => {
    return API.get(`statementAccounts/${statementaccountRef}`)
      .then(async (response) => {
        dispatch(setRevision(response.data._revision));
      })
      .catch(() => {
        notify(
          'There was an issue getting your payment plan. Please contact your insurance agent.',
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      });
  };
};
